import { render, staticRenderFns } from "./CardFriend.vue?vue&type=template&id=b6af8840&scoped=true"
import script from "./CardFriend.vue?vue&type=script&lang=js"
export * from "./CardFriend.vue?vue&type=script&lang=js"
import style0 from "./CardFriend.vue?vue&type=style&index=0&id=b6af8840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6af8840",
  null
  
)

export default component.exports